import { defineStore } from 'pinia';
import apiFetch from '@wordpress/api-fetch';

export const useContactsStore = defineStore('contacts', {
  state: () => ({
    contacts: [],
  }),

  actions: {
    loadContacts(params = {}) {
      this.contacts = [];

      const query = new URLSearchParams();

      if (params.lang) {
        query.append('lang', params.lang);
      }

      if (params.country?.length) {
        query.append('country', params.country.join(','));
      }

      if (params.region?.length) {
        query.append('region', params.region.join(','));
      }

      if (params.sector?.length) {
        query.append('sector', params.sector.join(','));
      }

      return apiFetch({
        path: `/wp-json/ebus/contacts?${query.toString()}`,
      }).then((contactsData) => {
        this.contacts = contactsData;

        return contactsData;

      }).catch((error) => {
        console.log('Error: ', error);
      });
    },
  },
})
